<template>
    <div class="form-box">
        <el-form
            class="form__center"
            label-width="82px"
            size="small"
        >
            <el-form-item label="手机号：">
                <el-input
                    v-model="formItem.new_phone"
                    placeholder="请输入新的手机号"
                    style="width: 200px;margin-right: 30px"
                />
            </el-form-item>
            <el-form-item label="验证码：">
                <el-input
                    v-model="formItem.new_valicode"
                    placeholder="请输入新手机验证码"
                    style="width: 200px;margin-right: 30px"
                />
                <el-button
                    type="text"
                    :disabled="showCount"
                    @click="sendCaptcha"
                >
                    <span v-show="!showCount">{{ text }}</span>
                    <span v-show="showCount">{{ count }}秒后重新发送</span>
                </el-button>
            </el-form-item>
            <el-form-item>
                <el-button
                    class="btn-standard"
                    type="primary"
                    @click="onSubmit"
                >
                    确认修改
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import qs from 'qs'

export default {
    name: 'Step2',
    inject: ['goPage'],
    data () {
        return {
            formItem: {
                new_phone: '',
                new_valicode: ''
            },
            showCount: false,
            timer: null,
            count: 60,
            text: '发送验证码'
        }
    },
    computed: {
        errors () {
            return this.$vuerify.$errors
        }
    },
    vuerify: {
        'formItem.new_phone': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入新的绑定手机'
            }, {
                test: /^1[3456789]\d{9}$/,
                message: '请输入正确的手机号'
            }
        ],
        'formItem.new_valicode': [
            {
                test: /^[\s\S]*.*[^\s][\s\S]*$/,
                message: '请输入新手机验证码'
            },
            {
                test: /^\d{6}$/,
                message: '请输入6位数字验证码'
            }
        ]
    },
    methods: {
        sendCaptcha () {
            if (!(/^1[3456789]\d{9}$/.test(this.formItem.new_phone))) {
                this.$message.error('请输入正确的手机号')
                return false
            }
            this.$http.post('/api/sendsms', qs.stringify({
                phone: this.formItem.new_phone,
                type: 5
            })).then(res => {
                if (res.code === 0) {
                    if (!this.timer) {
                        this.count = 60
                        this.showCount = true
                        this.timer = setInterval(() => {
                            if (this.count > 0 && this.count <= 60) {
                                this.count--
                            } else {
                                this.showCount = false
                                clearInterval(this.timer)
                                this.timer = null
                                this.text = '重新发送'
                            }
                        }, 1000)
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
                .catch(err => {
                    console.log(err)
                })
        },
        onSubmit () {
            if (!this.$vuerify.check()) {
                if (typeof (this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]]) !== 'string') {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]][0])
                } else {
                    this.$message.error(this.$vuerify.$errors[Object.keys(this.$vuerify.$errors)[0]])
                }
            } else {
                this.$http.post('/api/user/resetphone', qs.stringify({
                    step: 1,
                    phone: this.formItem.new_phone,
                    code: this.formItem.new_valicode
                })).then(res => {
                    if (res.code === 0) {
                        this.$notify.success({
                            title: '通知',
                            message: `手机号修改成功。`
                        })
                        this.goPage('/index/info/safe')
                    } else {
                        this.$message.error(res.message)
                    }
                })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .form__center {
        width: 402px;
    }
</style>
